import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Input.scss';


const Input = ({ id, type, value, readOnly, inputChange, inputBlur = () => {}, isError = false, placeholder = null, label = null, extraAttrs = {} }) => {
	const inputChangeHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputChange($input.id, $input.value);
	};

	const inputBlurHandler = (e) => {
		const $input = e.currentTarget;
		inputBlur($input.id, $input.value);
	};

	placeholder = placeholder || null;
	label = label || null;
	const labelClasses = [s.label];
	if (value.length > 0) labelClasses.push(s.label__hasText);
	if (isError === true) labelClasses.push(s.label__error);
	if (readOnly) extraAttrs = { ...extraAttrs, tabIndex: -1 };

	const input = <input className={s.input} id={id} name={id} readOnly={readOnly} type={type} value={value || ''} placeholder={placeholder} onChange={inputChangeHandlar} onBlur={inputBlurHandler} {...extraAttrs} />;

	if (label) {
		return (
			<label className={labelClasses.join(' ')} htmlFor={id}>
				{ input }
				<span className={s.input_labelText}>{ label }</span>
			</label>
		);
	}
	return input;
};

export default hot(module)(Input);
